export const GOOGLE_AUTH_ID = process.env.REACT_APP_GOOGLE_AUTH_ID;
export const baseURL = process.env.REACT_APP_BASE_URL;
export const SELF_HOST = process.env.REACT_APP_SELF_HOST;
export const WEBWHIZ_WIDGET_URL = process.env.REACT_APP_WEBWHIZ_WIDGET_URL || 'https://widget.webwhiz.ai';